import { memo } from "react";
import { Flex, Text } from "@radix-ui/themes";

type CountdownUnitProps = {
  value: number;
  label: string;
};

function CountdownUnit({ value, label }: CountdownUnitProps) {
  return (
    <Flex
      direction="column"
      align="center"
      className="rounded-lg bg-white/10 px-3 py-2 min-w-[60px] lg:min-w-[72px]"
    >
      <Text className="font-figtree text-[28px] lg:text-[36px] font-bold leading-none text-white tabular-nums">
        {String(value).padStart(2, "0")}
      </Text>
      <Text className="text-[10px] lg:text-[11px] font-semibold uppercase tracking-widest text-white/40 mt-1">
        {label}
      </Text>
    </Flex>
  );
}

export default memo(CountdownUnit);
